module.exports = __webpack_public_path__ + "img/ripple-stellar.668ccb62.png";